import { render } from "./AppointmentHist.vue?vue&type=template&id=1404c619"
import script from "./AppointmentHist.vue?vue&type=script&lang=js"
export * from "./AppointmentHist.vue?vue&type=script&lang=js"

import "./AppointmentHist.vue?vue&type=style&index=0&id=1404c619&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__